import { Head, Link } from '@inertiajs/react'
import AppLayout from '@/layouts/AppLayout'
import { PageProps } from '@/types'
import { BarChart3, ChevronRight } from 'lucide-react'

interface Report {
  key: string
  name: string
  description: string
}

interface Props extends PageProps {
  reports: Report[]
}

export default function ReportsIndex({ reports }: Props) {
  return (
    <AppLayout>
      <Head title="Reports" />
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-chestnut-charcoal font-heading">Reports</h1>
          <p className="text-chestnut-charcoal/70 mt-1">
            Recruiting and production reports across your organization. Each report supports date filters, sorting, search, and CSV export.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {reports.map((r) => (
            <Link
              key={r.key}
              href={`/admin/reports/${r.key}`}
              className="bg-white border border-chestnut-gray rounded-xl p-5 hover:border-chestnut-forest/40 hover:shadow-sm transition-all group"
            >
              <div className="flex items-start gap-4">
                <div className="p-2.5 bg-chestnut-forest/10 rounded-lg">
                  <BarChart3 className="h-5 w-5 text-chestnut-forest" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="text-lg font-semibold text-chestnut-charcoal">{r.name}</h3>
                    <ChevronRight className="h-4 w-4 text-chestnut-charcoal/40 group-hover:text-chestnut-forest transition-colors" />
                  </div>
                  <p className="text-sm text-chestnut-charcoal/70 mt-1">{r.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </AppLayout>
  )
}
